<script lang="ts">
  import Alwan from 'alwan';
  import {createEventDispatcher, onMount} from 'svelte';
  import {getInstance} from '../../../../services/animation';
  import {thumbColorPaletteStore} from './PalleteSelection.svelte';
  export let editorInstance: any;
  const dispatch = createEventDispatcher();
  export let color: string;
  let dom: HTMLElement;
  let pickerElement: HTMLElement;
  $: if (dom && color) dom.style.backgroundColor = color;

  function openColorPicker() {
    let brandKitColors = [];
    if (window.brandKit) {
      brandKitColors = [window.brandKit.color1, window.brandKit.color2, window.brandKit.color3].filter(
        item => item !== null
      );
    }
    const colors = $thumbColorPaletteStore;
    const picker = new Alwan(pickerElement, {
      color,
      swatches: [...brandKitColors, ...colors]
    });
    picker.open();
    picker.on('change', (c: any) => {
      // editorInstance.history.addHistory('color change')
      color = c.hex;
      dispatch('color-change', {color});
    });
    picker.on('close', () => {
      picker.destroy();
      getInstance().templateLoader.colorLoader.readColors();
    });
  }
  function onMouseEnter() {
    const domain = getInstance().templateLoader.colorLoader.getDomain(color);
    const elements = domain?.elements.map(e => e.element) as HTMLElement[];
    if (elements) {
      editorInstance.ui.highlight(elements);
    }
  }
  function onMouseLeave() {
    const domain = getInstance().templateLoader.colorLoader.getDomain(color);
    editorInstance.ui.removeHighlight();
  }
</script>

{#if color}
  <div
    class="relative flex-grow cursor-pointer p-2"
    bind:this={dom}
    on:keydown={openColorPicker}
    on:click={openColorPicker}
    on:mouseenter={onMouseEnter}
    on:mouseleave={onMouseLeave}
  >
    <div class="absolute left-5 top-2" bind:this={pickerElement} />
  </div>
{/if}
